import type { ParentProps } from "solid-js"
import { Spinner } from "@mux/ui/spinner"

export function DashboardLoadingScreen(props: ParentProps<{ label: string; contained?: boolean }>) {
  return (
    <div
      class="flex items-center justify-center bg-background-base"
      classList={{ "h-dvh w-screen": !props.contained, "size-full": !!props.contained }}
      role="status"
      aria-live="polite"
    >
      <div class="flex flex-col items-center gap-3 px-6 text-center">
        <Spinner class="size-5 text-icon-base" />
        <span class="text-13-regular text-text-weak">{props.label}</span>
        {props.children}
      </div>
    </div>
  )
}
